(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auto-banner"] && !Shopify.designMode) return;
  try {
    
  const handleBlk = (id) => {
    const blocks = [];
    const elements = document.querySelectorAll(`[id="${id}"]`);

    elements.forEach((elem) => {
      blocks.push({
        type: elem.dataset.type,
        link: elem.dataset.link,
        utm: elem.dataset.utm,
        image: elem.dataset.img,
        atributes: elem.dataset.attr,
      });
      elem.remove();
    });

    return blocks;
  };

  const readUtms = () => {
    const params = new URLSearchParams(window.location.search);
    const utms = {};

    params.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        utms[key] = value;
      }
    });

    return utms;
  };

  const getCookie = (name) => {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [cookieName, ...rest] = cookie.split('=');
      if (cookieName === name) {
        return { name, value: rest.join('=') };
      }
    }
    return null;
  };

  window.addEventListener('load', () => {
    const swiper_speed = parseInt(document.getElementById("bn-swiper").dataset.speed || "1300")
    const utms = readUtms();
    const blocks = handleBlk('banner-data');

    blocks.forEach(({ type, utm, link, image, atributes }) => {
      const [utmKey, utmExpectedValue] = utm.split('=');
      const cookie = getCookie(utmKey);
      const urlUtmValue = utms[utmKey];

      const matchesCookie = cookie?.value === utmExpectedValue;
      const matchesUrlParam = urlUtmValue === utmExpectedValue;

      console.log('Checking UTM:', {
        utmKey,
        utmExpectedValue,
        urlUtmValue,
        cookieValue: cookie?.value,
      });

      if (matchesCookie || matchesUrlParam) {
        const swiperSelector = type === 'desktop' ? '#swiper-desktop' : '#swiper-mobile';
        const swiperContainer = document.querySelector(swiperSelector);

        if (swiperContainer) {
          swiperContainer.innerHTML += `
        <a class="swiper-slide" id="bn-swiper-slide" href="${link}" ${atributes || ''}>
          <img src="${image}" alt="">
        </a>`;
        }
      }
    });

    new Swiper('.swiper', {
      effect: 'slide',
      loop: true,
      centeredSlides: true,
      direction: 'horizontal',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: true,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      },
      speed: swiper_speed
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
